import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import ArticlesSection from './components/ArticlesSection';
import ArticleCta from './components/ArticleCta';
import JsonLd, { siteUrl, siteName, logoUrl } from '@/components/feature/JsonLd';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('hero.title');
  }, [t]);

  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: `${siteUrl}/`,
        name: siteName,
        description:
          'USFans Spreadsheet guide with creator lists, directories, reviews, shipping, coupons and safety tips. An independent informational resource to help you browse USFans creators and resources.',
        inLanguage: 'en',
        publisher: { '@id': `${siteUrl}/#organization` },
      },
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: siteName,
        url: `${siteUrl}/`,
        logo: { '@type': 'ImageObject', url: logoUrl },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-[#fbfaf8]">
      <JsonLd data={homeJsonLd} />
      <SiteHeader />
      <main>
        <Hero />
        <TrustBar />
        <CategorySection />
        <AboutSection />
        <ArticlesSection />
        <ArticleCta />
      </main>
      <SiteFooter />
    </div>
  );
}